import React from "react";
import companyInfo from "../data/companyInfo";

function Footer() {
  const copyrightMsg = `Copyright ${new Date().getFullYear()} Bizmak | All rights reserved`;

  return (
    <footer className="footer bizmak-footer text-center text-lg-start">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-4">
            <h4>Contact</h4>
            <p className="mb-2">
              <a className="footer-link" href="tel:+14439515651">
                <i className="fas fa-phone me-2" aria-hidden="true" />
                443-951-5651
              </a>
            </p>
            <p className="mb-2">
              <a className="footer-link" href="#contact">
                <i className="fas fa-envelope me-2" aria-hidden="true" />
                Send us a message
              </a>
            </p>
            <p className="mb-0 footer-address">
              <i className="fas fa-location-dot me-2" aria-hidden="true" />
              Catonsville, MD
            </p>
          </div>
          <div className="col-lg-4 text-lg-center">
            <h4>Social</h4>
            <a
              className="btn btn-outline-light btn-social mx-1"
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f" aria-hidden="true" />
            </a>
            <a
              className="btn btn-outline-light btn-social mx-1"
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
            >
              <i className="fab fa-twitter" aria-hidden="true" />
            </a>
            <a
              className="btn btn-outline-light btn-social mx-1"
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin-in" aria-hidden="true" />
            </a>
          </div>
          <div className="col-lg-4 text-lg-end">
            <h4>Explore</h4>
            <p className="mb-1">
              <a className="footer-link" href="#page-top">
                Home
              </a>
            </p>
            <p className="mb-1">
              <a className="footer-link" href="#service">
                Services
              </a>
            </p>
            <p className="mb-1">
              <a
                className="footer-link"
                href={companyInfo.federal.capabilityStatementUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Capability statement
              </a>
            </p>
            <p className="mb-0">
              <a className="footer-link" href="#contact">
                Contact
              </a>
            </p>
          </div>
        </div>
        <div className="bizmak-copyright-bar text-center">
          <small className="d-block text-muted">
            {copyrightMsg}
          </small>
          <small className="d-block text-muted mt-1">
            UEI: D3ALVYC51FJ6 &nbsp;|&nbsp; CAGE: 9GFT0 &nbsp;|&nbsp; SAM.gov
            registered federal supplier
          </small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
